import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';
import { FontSizingElements, generateFontSizing } from 'app/styles/mixins';
import { Image } from 'app/shared/components/Image/Image';

export type Headings = 2 | 3 | 4 | 5 | 6;

interface SectionHeadingStProps {
  level?: Headings;
}

export const SectionContainerSt = styled.div`
  padding-top: 1.5rem;
`;

export const SectionHeadingSt = styled.div<SectionHeadingStProps>`
  text-align: left;

  ${({ level }) => (level === 2 ? 'padding: 0.5rem 0;' : '')}
  ${({ level }) =>
    level >= 2 && level <= 6
      ? `${generateFontSizing(`h${level}` as FontSizingElements)};`
      : ''};
`;
export const SectionContentSt = styled.div``;

export const ImageSt = styled(Image)`
  float: right;
  margin-left: 1rem;
  margin-bottom: 1rem;
  ${media.sm(css`
    max-width: 50%;
    margin-bottom: 0;
  `)};
`;
